import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { SidebarCounterBadge } from '../counterBadge';
import { SidebarSectionItemProps } from './model';

export const SidebarSectionItem: React.FC<SidebarSectionItemProps> = (props) => {
  if ('component' in props) {
    const Component = props.component;
    return <Component />;
  }

  const { badgeValue, href, title } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 2, md: 4 }, mt: 1, mb: 1 }}>
      <SidebarCounterBadge value={badgeValue} />

      <Link href={href} sx={{ display: 'flex', alignItems: 'center' }} underline={false}>
        <Typography variant="body bold">{title}</Typography>
      </Link>
    </Box>
  );
};
